import React from 'react'

const PauseIcon = ({ color = '#fff' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14">
      <rect data-name="Rectangle 1576" width={14} height={14} rx={2} style={{ fill: color }} />
    </svg>
  )
}

export default PauseIcon
